import React, { useState } from 'react'
import { Part } from '../../../types/part/partTypes'
import Badge from '../Badge/Badge'
import ModalOzonDetails from '../../_molecules/ModalOzonDetails/ModalOzonDetails'

interface IProps {
    part: Part
}

const CellOzonData = ({ part }: IProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const ozonData = part.extraData?.ozonData

    if (!ozonData) {
        return <span>-</span>
    }

    const handleMoreDetailsClick = () => {
        setIsModalOpen(true)
    }

    const formatPrice = (price: string | undefined) => {
        if (!price) return '-'
        return parseFloat(price).toLocaleString('ru-RU', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })
    }

    const formatSKULink = (sku: number | undefined) => {
        if (!sku) return '-'
        return (
            <a 
                href={`https://ozon.ru/product/${sku}`} 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ color: '#007bff', textDecoration: 'none' }}
            >
                [{sku}]
            </a>
        )
    }

    const getStatusColor = (status: string | undefined) => {
        switch (status) {
            case 'price_sent':
                return '#28a745' // зеленый
            case 'moderation':
                return '#ffc107' // желтый
            case 'rejected':
                return '#dc3545' // красный
            default:
                return '#6c757d' // серый
        }
    }

    const getStockStatus = () => {
        if (ozonData.OzonHasStock) {
            return <span style={{ color: '#28a745', fontWeight: 'bold' }}>✓ В наличии</span>
        } else {
            return <span style={{ color: '#dc3545', fontWeight: 'bold' }}>✗ Нет в наличии</span>
        }
    }

    return (
        <div style={{ fontSize: '12px', lineHeight: '1.2' }}>
            {/* <div style={{ marginBottom: '2px' }}>
                <strong>SKU:</strong> {formatSKULink(ozonData.OzonSKU)}
            </div> */}
            {/* <div style={{ marginBottom: '4px' }}>
                <strong>Наличие:</strong> {getStockStatus()}
            </div> */}
            <div style={{ marginBottom: '2px' }}>
                <strong>Статус:</strong> 
                <span style={{ 
                    color: getStatusColor(ozonData.OzonStatuses?.status),
                    fontWeight: 'bold',
                    marginLeft: '4px'
                }}>
                    {ozonData.OzonStatuses?.status_name || ozonData.OzonStatuses?.status || '-'}
                </span>
            </div>
            <div style={{ marginBottom: '2px' }}>
                <strong>Цена:</strong> {formatPrice(ozonData.OzonPrice)}
            </div>
            <div>
                <button
                    onClick={handleMoreDetailsClick}
                    style={{
                        background: 'none',
                        border: 'none',
                        color: '#007bff',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        fontSize: '11px',
                        padding: 0
                    }}
                >
                    Подробнее
                </button>
            </div>
            
            <ModalOzonDetails 
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                ozonData={ozonData}
            />
        </div>
    )
}

export default CellOzonData
